/* T FOR ALL — pre-order: after a variant change, take the button label and the pre-order
   messages from the re-rendered section (Dawn resets the label to "Add to cart"). */
(function () {
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var html = event.data && event.data.html;
    var sectionId = event.data && event.data.sectionId;
    if (!html || !sectionId) return;

    var source = html.getElementById('ProductSubmitButton-' + sectionId);
    var target = document.getElementById('ProductSubmitButton-' + sectionId);
    if (source && target && !source.hasAttribute('disabled')) {
      var label = source.querySelector('span');
      var targetLabel = target.querySelector('span');
      if (label && targetLabel) targetLabel.textContent = label.textContent;
    }

    html.querySelectorAll('[data-pre-order]').forEach(function (message) {
      var current = document.getElementById(message.id);
      if (current) current.hidden = message.hidden;
    });
  });
})();
